import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.quiz');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-page-quiz',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.quiz/view.scss */
/* src/app/page.quiz/view.scss: no such file or directory */`],
})
export class PageQuizComponent implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default PageQuizComponent;